import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import Cookies from "js-cookie";

import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import PrintPage from "../../../../components/common/PrintPage/PrintPage";
import TextInfo from "../../../../components/common/TextInfo/TextInfo";
import SwalToast from "../../../../components/helpers/SwalToast";

import { convertTransactionDetail } from "../../transaction_history/pawn_transaction/helpers";

import "../DetailDialog/styles.css";

const headingStyle = {
  fontSize: "20px",
  marginBottom: "1rem",
  fontWeight: "bold",
};

const PrintNota = ({ match }) => {
  const [data, setData] = useState({});
  const [type, setType] = useState("");
  const transactionID = match.params.id;

  const getTransactionDetail = () => {
    const data = {
      transaction_id: transactionID,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/detail`;

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data
      ),
      (response) => {
        const detail = convertTransactionDetail(response.data.data);

        setData(detail);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data detail transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  useEffect(() => {
    const path = match.path.split("/").filter((val) => val);

    if (path.includes("pawn")) {
      setType("pawn");
    } else if (path.includes("capital-cash")) {
      setType("capital");
    }
    getTransactionDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.path]);

  const nonTunaiDetail = (
    <>
      <TextInfo title="Bank" value={data?.customerBankName} />
      <TextInfo title="No. Rekening" value={data?.customerAccountNumber} />
      <TextInfo title="Atas Nama" value={data?.customerAccountName} />
    </>
  );

  const paymentDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo
        title={
          type === "pawn" ? "Penyimpanan Keterlambatan" : "Biaya Penyimpanan"
        }
        value={data?.lateStorageFee}
      />
      <TextInfo title="Total Pembayaran" value={data?.totalPayment} />
    </div>
  );

  const loanDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      {type === "pawn" && (
        <TextInfo title="Nilai Valuasi" value={data?.valuationValue} />
      )}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Sewa Modal" value={data?.loanCapital} />
      <TextInfo title="Biaya Administrasi" value={data?.adminFee} />
      <TextInfo
        title="Biaya Simpan & Asuransi"
        value={data?.storeAndInsuranceFee}
      />
      <TextInfo title="Biaya Transfer" value={data?.transferFee} />
      <TextInfo title="Jumlah Diterima" value={data?.amountReceived} />
    </div>
  );

  const extensionDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Sewa Modal" value={data?.loanCapital} />
      <TextInfo title="Administrasi" value={data?.adminFee} />
      <TextInfo title="Simpan & Asuransi" value={data?.storeAndInsuranceFee} />
      <TextInfo
        title="Biaya Nilai Revaluasi"
        value={data?.revaluationValueFee}
      />
      <TextInfo title="Total Pembayaran" value={data?.totalPayment} />
    </div>
  );

  const lelangDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Biaya Jasa Lelang" value={data?.auctionServiceFee} />
      <TextInfo title="Harga Lelang" value={data?.auctionPrice} />
      <TextInfo title="Sisa Lelang" value={data?.auctionRemaining} />
    </div>
  );

  const refundDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Jenis Pengembalian" value={data?.returnType} />
      <TextInfo title="Keterangan" value={data?.description} />
      <TextInfo title="Jumlah Pengembalian" value={data?.returnTotal} />
    </div>
  );

  const latePayment = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo title="Denda Penyimpanan" value={data?.lateStorageFee} />
      <TextInfo title="Total Denda" value={data?.totalPayment} />
    </div>
  );

  const renderDetail = () => {
    if (data?.transactionType.toLowerCase() === "disburse-loan") {
      return loanDetail;
    } else if (data?.transactionType.toLowerCase() === "payment-loan") {
      return paymentDetail;
    } else if (data?.transactionType.toLowerCase() === "extension") {
      return extensionDetail;
    } else if (data?.transactionType.toLowerCase() === "auction") {
      return lelangDetail;
    } else if (data?.transactionType.toLowerCase() === "refund") {
      return refundDetail;
    } else if (data?.transactionType.toLowerCase() === "late-payment") {
      return latePayment;
    }
  };

  return (
    <PrintPage>
      <div>
        <div style={headingStyle} className="heading">
          Nota
        </div>
        <div className="detail-header">
          <TextInfo title="Tanggal/Waktu" value={data?.dateTime || "-"} />
          <TextInfo
            title="No. Surat Bukti Gadai"
            value={data?.gadaiCode || "-"}
          />
          <TextInfo title="No. Kwitansi" value={data?.receiptNumber || "-"} />
          <TextInfo title="Nama Nasabah" value={data?.customerName || "-"} />
          {data?.transactionType?.toLowerCase() !== "lelang" && (
            <TextInfo title="Nama Officer" value={data?.officerName || "-"} />
          )}
        </div>
        <Divider dashed className="detail-divider nota-divider" />
        {!data || !Object.keys(data).length ? "Tidak ada data" : renderDetail()}
        <Divider dashed className="detail-divider nota-divider" />
        <div className="detail-footer">
          <div>
            Cetak dan simpan nota ini sebagai bukti pencairan pinjaman dan
            transaksi yang sah.
          </div>
          <div>PT. deGadai Solusi Utama</div>
        </div>
      </div>
    </PrintPage>
  );
};

export default PrintNota;
